<!--function start-->
<section class="app2 format quality p-t-0">
  <!-- <div class="animated-bg"><i></i><i></i><i></i></div> -->
  <div class="container">
    <div class="row">
      <div class="col-sm-6 counters set-order-2">
        <div class="abouts center-text">
          <div>
            <div class="format-head-text">
              <h3 class="about-font-header font-secondary">
                {{ 'headers.modernFunction' | translate }}
              </h3>
            </div>
            <!-- <div class="format-sub-text">
              <p class="about-para">
               {{ 'thirdHeader.description' | translate }}
              </p>
            </div> -->

            <ul class="icon-collection">
              <li class="about-icon">
                <a href="#" class="center-content">
                  <h4 class="quality">
                    {{ 'features2.featHeader1' | translate }}
                  </h4>
                  <h6 class="users">{{ 'features2.featText1' | translate }}</h6>
                </a>
              </li>
              <li class="about-icon">
                <a href="#" class="center-content">
                  <h4 class="quality">
                    {{ 'features2.featHeader2' | translate }}
                  </h4>
                  <h6 class="users">{{ 'features2.featText2' | translate }}</h6>
                </a>
              </li>
            </ul>
            <ul class="icon-collection" style="margin-top: 20px">
              <li class="about-icon">
                <a href="#" class="center-content">
                  <h4 class="quality">
                    {{ 'features2.featHeader3' | translate }}
                  </h4>
                  <h6 class="users">{{ 'features2.featText3' | translate }}</h6>
                </a>
              </li>
              <li class="about-icon">
                <a href="#" class="center-content">
                  <h4 class="quality">
                    {{ 'features2.featHeader4' | translate }}
                  </h4>
                  <h6 class="users">{{ 'features2.featText4' | translate }}</h6>
                </a>
              </li>
            </ul>
            <!-- <a class="btn btn-default btn-gradient m-t-45">learn more</a> -->

            <div class="col-md-10 offset-md-1 text-center mt-5">
              <ul>
                <!-- <li style="margin-bottom: 10px">
                  <a class="btn btn-default btn-white" href="" target="_blank">
                    <i class="fa fa-android"></i>
                    {{ 'buttonAndroidApp' | translate }}</a
                  >
                </li> -->
                <li style="margin-bottom: 10px">
                  <a
                    class="btn btn-default btn-white"
                    href="https://apps.apple.com/us/app/fish-mate/id6743015861"
                    target="_blank"
                  >
                    <i class="fa fa-apple"></i>
                    {{ 'buttonIosApp' | translate }}</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div
        class="col-sm-6 counters set-height overflow-hide"
        [@fadeInRight]="fadeInRight"
      >
        <img
          src="assets/images/app_landing2/l-2.png"
          alt=""
          class="img-fluid mobile2"
          data-aos-duration="1500"
        />
      </div>
    </div>
  </div>
</section>
<!--function end-->
